(function () {
  const STORAGE_KEY = "oi_wishlist_v1";
  const PAGE_WISHLIST = "/pages/wishlist";
  const SHARE_PARAM = "wl";
  const state = {
    items: [],
    toastTimer: null
  };

  function readItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeItems(items) {
    state.items = items;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent("oi:wishlist:updated", { detail: { items } }));
  }

  function encodeSharePayload(items) {
    try {
      const payload = items.map((item) => ({ h: item.handle, v: item.variantId || null }));
      return btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    } catch (e) {
      return "";
    }
  }

  function decodeSharePayload(token) {
    try {
      const json = decodeURIComponent(escape(atob(token)));
      const parsed = JSON.parse(json);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function buildShareUrl() {
    const token = encodeSharePayload(state.items);
    const url = new URL(PAGE_WISHLIST, window.location.origin);
    if (token) url.searchParams.set(SHARE_PARAM, token);
    return url.toString();
  }

  function normalizeProductUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname;
    } catch (e) {
      return url || "";
    }
  }

  function getHandleFromUrl(url) {
    const match = normalizeProductUrl(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  function isInWishlist(handle) {
    return state.items.some((item) => item.handle === handle);
  }

  function toggleItem(item) {
    const exists = isInWishlist(item.handle);
    if (exists) {
      const next = state.items.filter((p) => p.handle !== item.handle);
      writeItems(next);
      showToast("Retire de vos favoris");
      return false;
    }
    writeItems([item].concat(state.items));
    showToast("Ajoute a vos favoris");
    return true;
  }

  function escapeHtml(value) {
    return (value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;");
  }

  function wishlistIcon() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M12.1 21.35l-1.1-1C5.14 15.24 2 12.39 2 8.89 2 6 4.24 3.75 7.13 3.75c1.64 0 3.22.76 4.24 2.02 1.02-1.26 2.6-2.02 4.24-2.02C18.5 3.75 20.75 6 20.75 8.89c0 3.5-3.14 6.35-8.99 11.46l-.66.58z"></path>' +
      "</svg>"
    );
  }

  function createButton(active, label, count) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "oi-wishlist-btn" + (active ? " is-active" : "");
    button.setAttribute("aria-label", label);
    button.innerHTML =
      wishlistIcon() +
      (label ? '<span class="oi-wishlist-label">' + escapeHtml(label) + "</span>" : "") +
      (typeof count === "number"
        ? '<span class="oi-wishlist-count-badge">' + count + "</span>"
        : "");
    return button;
  }

  function parseCard(card) {
    const link =
      card.querySelector('a[href*="/products/"]') ||
      card.querySelector('.full-unstyled-link[href*="/products/"]');
    if (!link) return null;

    const image = card.querySelector("img");
    const priceEl = card.querySelector(".price, .x-card-price, [class*='price']");
    const titleEl = card.querySelector(".card-product-title, .full-unstyled-link, .card__heading, h3, h2");
    const handle = getHandleFromUrl(link.getAttribute("href"));
    if (!handle) return null;

    return {
      handle: handle,
      url: normalizeProductUrl(link.href),
      title: (titleEl ? titleEl.textContent : link.textContent || "").trim(),
      image: image ? image.currentSrc || image.src : "",
      price: priceEl ? priceEl.textContent.trim() : "",
      variantId: null
    };
  }

  async function ensureVariantId(item) {
    if (item.variantId) return item;
    try {
      const response = await fetch("/products/" + item.handle + ".js");
      if (!response.ok) return item;
      const product = await response.json();
      const available = (product.variants || []).find((v) => v.available);
      const selected = available || (product.variants || [])[0];
      if (!selected) return item;
      item.variantId = selected.id;
      writeItems(state.items.map((it) => (it.handle === item.handle ? item : it)));
      return item;
    } catch (e) {
      return item;
    }
  }

  async function getProductCardData(handle, variantId) {
    try {
      const response = await fetch("/products/" + handle + ".js");
      if (!response.ok) return null;
      const product = await response.json();
      const selected = (product.variants || []).find((v) => v.id === Number(variantId));
      const fallback = (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
      const chosen = selected || fallback;
      if (!chosen) return null;
      return {
        handle: product.handle,
        url: "/products/" + product.handle,
        title: product.title,
        image: product.featured_image || "",
        price: new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
          (chosen.price || 0) / 100
        ),
        variantId: chosen.id
      };
    } catch (e) {
      return null;
    }
  }

  async function hydrateWishlistFromShareUrl() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get(SHARE_PARAM);
    if (!token) return;
    const decoded = decodeSharePayload(token);
    if (!decoded.length) return;
    const list = [];
    for (const row of decoded.slice(0, 60)) {
      if (!row || !row.h) continue;
      const item = await getProductCardData(row.h, row.v);
      if (item) list.push(item);
    }
    if (!list.length) return;
    const merged = state.items.length
      ? state.items.concat(list.filter((it) => !state.items.some((s) => s.handle === it.handle)))
      : list;
    writeItems(merged);
  }

  async function addToCart(item) {
    const enriched = await ensureVariantId(item);
    if (!enriched.variantId) {
      showToast("Variant indisponible");
      return;
    }
    const cartHelper =
      window.Alpine && typeof window.Alpine.store === "function"
        ? window.Alpine.store("xCartHelper")
        : null;
    const payload = { id: enriched.variantId, quantity: 1 };
    if (cartHelper && typeof cartHelper.getSectionsToRender === "function") {
      payload.sections = cartHelper.getSectionsToRender().map((section) => section.id);
    }
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    if (response.ok) {
      const parsed = await response.json();
      showToast("Ajoute au panier");

      if (cartHelper && parsed && parsed.sections && typeof cartHelper.reRenderSections === "function") {
        cartHelper.reRenderSections(parsed.sections);
      }

      try {
        const cartRes = await fetch("/cart.js", { headers: { Accept: "application/json" } });
        if (cartRes.ok) {
          const cart = await cartRes.json();
          if (cartHelper && typeof cart.item_count === "number") {
            cartHelper.currentItemCount = cart.item_count;
          }
        }
      } catch (e) {
        // no-op
      }

      document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
      document.dispatchEvent(new CustomEvent("eurus:cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
    } else {
      showToast("Impossible d'ajouter au panier");
    }
  }

  function enhanceCards() {
    const cards = document.querySelectorAll(".card-product, .x-product-card, .card-wrapper");
    cards.forEach((card) => {
      if (card.querySelector(".oi-wishlist-btn")) return;
      const item = parseCard(card);
      if (!item) return;
      const active = isInWishlist(item.handle);
      const button = createButton(active, "", undefined);
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const isActive = toggleItem(item);
        button.classList.toggle("is-active", isActive);
      });
      if (getComputedStyle(card).position === "static") {
        card.style.position = "relative";
      }
      card.appendChild(button);
    });
  }

  function getProductDataFromJsonLd() {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      try {
        const json = JSON.parse(script.textContent);
        if (json && (json["@type"] === "Product" || (Array.isArray(json) && json.some((x) => x["@type"] === "Product")))) {
          const product = Array.isArray(json) ? json.find((x) => x["@type"] === "Product") : json;
          if (product && product.url) {
            return {
              handle: getHandleFromUrl(product.url),
              url: normalizeProductUrl(product.url),
              title: product.name || document.title,
              image: Array.isArray(product.image) ? product.image[0] : product.image || "",
              price: ""
            };
          }
        }
      } catch (e) {}
    }
    return null;
  }

  function getProductDataFromPage() {
    if (!window.location.pathname.includes("/products/")) return null;
    const handle = getHandleFromUrl(window.location.pathname);
    if (!handle) return null;

    const titleEl =
      document.querySelector("h1.product-title") ||
      document.querySelector("h1") ||
      document.querySelector('meta[property="og:title"]');
    const imageMeta =
      document.querySelector('meta[property="og:image"]') ||
      document.querySelector('meta[name="twitter:image"]');
    const canonical = document.querySelector('link[rel="canonical"]');

    return {
      handle: handle,
      url: normalizeProductUrl(canonical ? canonical.href : window.location.pathname),
      title: titleEl ? (titleEl.content || titleEl.textContent || "").trim() : document.title,
      image: imageMeta ? imageMeta.content : "",
      price: ""
    };
  }

  function enhancePdp() {
    const isProductPage = window.location.pathname.includes("/products/");
    if (!isProductPage) return;
    if (document.querySelector("[data-oi-wishlist-static]")) return;
    const submitBtn =
      document.querySelector('button[name="add"]') ||
      document.querySelector('#x-atc-button') ||
      document.querySelector('[id^="x-atc-button-"]') ||
      document.querySelector('button[type="submit"][role="button"]');
    const form = submitBtn ? submitBtn.closest("form") : document.querySelector('form[action*="/cart/add"]');
    const existing =
      (form && form.querySelector(".oi-wishlist-pdp-wrap")) ||
      document.querySelector(".product-content-container .oi-wishlist-pdp-wrap") ||
      document.querySelector("#ProductInfo-main .oi-wishlist-pdp-wrap");
    if (!submitBtn || existing) return;

    const data = getProductDataFromJsonLd() || getProductDataFromPage();
    if (!data || !data.handle) return;
    data.variantId = (function () {
      const variantInput = (form || document).querySelector('input[name="id"]');
      return variantInput ? Number(variantInput.value) : null;
    })();

    const wrap = document.createElement("div");
    wrap.className = "oi-wishlist-pdp-wrap";
    const button = createButton(
      isInWishlist(data.handle),
      isInWishlist(data.handle) ? "Retirer de la wishlist" : "Ajouter a la wishlist",
      undefined
    );
    button.addEventListener("click", function () {
      const active = toggleItem(data);
      button.classList.toggle("is-active", active);
      const label = button.querySelector(".oi-wishlist-label");
      if (label) label.textContent = active ? "Retirer de la wishlist" : "Ajouter a la wishlist";
    });
    wrap.appendChild(button);
    const productInfo =
      document.querySelector('[id^="ProductInfo-"]') ||
      submitBtn.closest(".product-info") ||
      document.querySelector(".product-content-container") ||
      document.querySelector("#ProductInfo-main");
    if (!productInfo) return;

    const buyBlock = productInfo.querySelector(".x-block-buy-buttons");
    const priceBlock = productInfo.querySelector(".x-block-price");

    if (buyBlock && buyBlock.parentElement) {
      buyBlock.insertAdjacentElement("afterend", wrap);
      return;
    }

    if (priceBlock && priceBlock.parentElement) {
      priceBlock.insertAdjacentElement("afterend", wrap);
      return;
    }

    productInfo.appendChild(wrap);
  }

  function initStaticPdpButtons() {
    const buttons = document.querySelectorAll("[data-oi-wishlist-pdp]");
    if (!buttons.length) return;

    buttons.forEach((button) => {
      if (button.dataset.oiBound === "true") return;
      button.dataset.oiBound = "true";

      const handle = button.getAttribute("data-handle") || getHandleFromUrl(window.location.pathname);
      if (!handle) return;
      const item = {
        handle: handle,
        url: button.getAttribute("data-url") || window.location.pathname,
        title: button.getAttribute("data-title") || document.title,
        image: button.getAttribute("data-image") || "",
        price: "",
        variantId: null
      };

      const variantInputId = button.getAttribute("data-variant-input");
      if (variantInputId) {
        const variantInput = document.getElementById(variantInputId);
        if (variantInput && variantInput.value) item.variantId = Number(variantInput.value);
      }

      button.classList.toggle("is-active", isInWishlist(handle));

      const label = button.querySelector(".oi-wishlist-label");
      if (label) {
        label.textContent = isInWishlist(handle) ? "Retirer de la wishlist" : "Ajouter a la wishlist";
      }

      button.addEventListener("click", function (event) {
        event.preventDefault();
        const variantInput = variantInputId ? document.getElementById(variantInputId) : null;
        if (variantInput && variantInput.value) item.variantId = Number(variantInput.value);
        const active = toggleItem(item);
        button.classList.toggle("is-active", active);
        const txt = button.querySelector(".oi-wishlist-label");
        if (txt) txt.textContent = active ? "Retirer de la wishlist" : "Ajouter a la wishlist";
      });
    });
  }

  function renderWishlistPage() {
    if (window.location.pathname !== PAGE_WISHLIST) return;
    const target = document.querySelector(".page__body .rte") || document.querySelector("#MainContent");
    if (!target) return;

    target.innerHTML =
      '<div class="oi-wishlist-page">' +
      '<div class="oi-wishlist-toolbar">' +
      "<h2>Vos favoris</h2>" +
      '<div class="oi-wishlist-share">' +
      '<button type="button" class="oi-wishlist-action" data-oi-copy>Copier le lien</button>' +
      '<a class="oi-wishlist-action" data-oi-whatsapp target="_blank" rel="noopener">WhatsApp</a>' +
      '<a class="oi-wishlist-action" data-oi-facebook target="_blank" rel="noopener">Facebook</a>' +
      '<a class="oi-wishlist-action" data-oi-pinterest target="_blank" rel="noopener">Pinterest</a>' +
      '<button type="button" class="oi-wishlist-action" data-oi-clear>Vider la wishlist</button>' +
      "</div>" +
      "</div>" +
      '<div class="oi-wishlist-reminder">' +
      "<p>Recevoir un rappel par email de votre wishlist</p>" +
      '<form action="/contact#contact_form" method="post" class="oi-wishlist-reminder-form">' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="wishlist_reminder">' +
      '<input type="hidden" name="contact[body]" data-oi-email-body value="">' +
      '<input type="email" name="contact[email]" placeholder="Votre email" required>' +
      '<button type="submit" class="oi-wishlist-action oi-wishlist-action--primary">Activer le rappel</button>' +
      "</form>" +
      "</div>" +
      '<div data-oi-wishlist-content></div>' +
      '<div class="oi-wishlist-reco" data-oi-reco-wrap></div>' +
      "</div>" +
      '<div class="oi-wishlist-toast" id="oiWishlistToast" role="status" aria-live="polite"></div>';

    const content = target.querySelector("[data-oi-wishlist-content]");
    const clearBtn = target.querySelector("[data-oi-clear]");
    const copyBtn = target.querySelector("[data-oi-copy]");
    const whatsapp = target.querySelector("[data-oi-whatsapp]");
    const facebook = target.querySelector("[data-oi-facebook]");
    const pinterest = target.querySelector("[data-oi-pinterest]");
    const emailBody = target.querySelector("[data-oi-email-body]");
    const recoWrap = target.querySelector("[data-oi-reco-wrap]");

    function updateShareLinks() {
      const shareUrl = buildShareUrl();
      const encoded = encodeURIComponent(shareUrl);
      const text = encodeURIComponent("Voici ma wishlist Ombre Interieur");
      if (whatsapp) whatsapp.href = "https://wa.me/?text=" + text + "%20" + encoded;
      if (facebook) facebook.href = "https://www.facebook.com/sharer/sharer.php?u=" + encoded;
      if (pinterest) pinterest.href = "https://pinterest.com/pin/create/button/?url=" + encoded;
      if (emailBody) {
        emailBody.value =
          "Wishlist: " +
          shareUrl +
          "\nProduits: " +
          state.items.map((it) => it.title + " (" + (it.url || "") + ")").join(", ");
      }
    }

    async function renderRecommendations() {
      if (!recoWrap) return;
      if (!state.items.length) {
        recoWrap.innerHTML = "";
        return;
      }
      const picks = [];
      const seen = new Set(state.items.map((i) => i.handle));
      for (const item of state.items.slice(0, 2)) {
        try {
          const product = await fetch("/products/" + item.handle + ".js").then((r) => (r.ok ? r.json() : null));
          if (!product || !product.id) continue;
          const reco = await fetch(
            "/recommendations/products.json?product_id=" + product.id + "&limit=6&intent=related"
          ).then((r) => (r.ok ? r.json() : null));
          const products = reco && Array.isArray(reco.products) ? reco.products : [];
          for (const p of products) {
            if (!p || !p.handle || seen.has(p.handle)) continue;
            seen.add(p.handle);
            picks.push(p);
            if (picks.length >= 4) break;
          }
          if (picks.length >= 4) break;
        } catch (e) {}
      }
      if (!picks.length) {
        recoWrap.innerHTML = "";
        return;
      }
      recoWrap.innerHTML =
        '<h3>Recommandes pour vous</h3><div class="oi-wishlist-reco-grid">' +
        picks
          .map((p) => {
            const img = p.featured_image ? p.featured_image : "";
            const price = typeof p.price === "number"
              ? new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(p.price / 100)
              : "";
            return (
              '<a class="oi-wishlist-reco-card" href="/products/' +
              escapeHtml(p.handle) +
              '">' +
              '<img loading="lazy" src="' +
              escapeHtml(img) +
              '" alt="' +
              escapeHtml(p.title || "") +
              '">' +
              '<p>' +
              escapeHtml(p.title || "") +
              "</p>" +
              '<span class="oi-wishlist-reco-price">' +
              escapeHtml(price) +
              "</span>" +
              "</a>"
            );
          })
          .join("") +
        "</div>";
    }

    function draw() {
      if (!state.items.length) {
        content.innerHTML =
          '<div class="oi-wishlist-empty">' +
          "<p>Votre wishlist est vide pour le moment.</p>" +
          '<p><a href="/collections/all">Decouvrir nos produits</a></p>' +
          "</div>";
        return;
      }

      content.innerHTML =
        '<div class="oi-wishlist-grid">' +
        state.items
          .map((item) => {
            return (
              '<article class="oi-wishlist-card" data-handle="' +
              escapeHtml(item.handle) +
              '">' +
              '<a class="oi-wishlist-card-image" href="' +
              escapeHtml(item.url || "/products/" + item.handle) +
              '">' +
              '<img loading="lazy" src="' +
              escapeHtml(item.image || "") +
              '" alt="' +
              escapeHtml(item.title || "") +
              '">' +
              "</a>" +
              '<div class="oi-wishlist-card-content">' +
              '<a class="oi-wishlist-card-title" href="' +
              escapeHtml(item.url || "/products/" + item.handle) +
              '">' +
              escapeHtml(item.title || item.handle) +
              "</a>" +
              '<div class="oi-wishlist-card-price">' +
              escapeHtml(item.price || "") +
              "</div>" +
              '<div class="oi-wishlist-actions">' +
              '<button type="button" class="oi-wishlist-action oi-wishlist-action--primary" data-oi-add-cart>Ajouter au panier</button>' +
              '<button type="button" class="oi-wishlist-action" data-oi-remove>Supprimer</button>' +
              "</div>" +
              "</div>" +
              "</article>"
            );
          })
          .join("") +
        "</div>";
      updateShareLinks();
      renderRecommendations();

      content.querySelectorAll("[data-oi-remove]").forEach((btn) => {
        btn.addEventListener("click", function () {
          const card = btn.closest("[data-handle]");
          const handle = card ? card.getAttribute("data-handle") : "";
          writeItems(state.items.filter((item) => item.handle !== handle));
          draw();
        });
      });

      content.querySelectorAll("[data-oi-add-cart]").forEach((btn) => {
        btn.addEventListener("click", async function () {
          const card = btn.closest("[data-handle]");
          const handle = card ? card.getAttribute("data-handle") : "";
          const item = state.items.find((it) => it.handle === handle);
          if (!item) return;
          btn.disabled = true;
          await addToCart(item);
          btn.disabled = false;
        });
      });
    }

    clearBtn.addEventListener("click", function () {
      if (!state.items.length) return;
      writeItems([]);
      draw();
      showToast("Wishlist videe");
    });
    if (copyBtn) {
      copyBtn.addEventListener("click", async function () {
        const url = buildShareUrl();
        try {
          await navigator.clipboard.writeText(url);
          showToast("Lien wishlist copie");
        } catch (e) {
          showToast("Copie impossible");
        }
      });
    }

    document.addEventListener("oi:wishlist:updated", draw);
    updateShareLinks();
    draw();
  }

  function renderHeaderShortcut() {
    const navTarget =
      document.querySelector('a[href="/cart"], a[href*="/cart"]') ||
      document.querySelector('a[href="/account"], a[href*="/account"]');
    if (!navTarget) return;
    if (document.querySelector("[data-oi-wishlist-shortcut]")) return;

    const link = document.createElement("a");
    link.href = PAGE_WISHLIST;
    link.setAttribute("data-oi-wishlist-shortcut", "true");
    link.style.marginInlineStart = "10px";
    link.style.display = "inline-flex";
    link.style.alignItems = "center";
    link.style.gap = "0";
    link.style.color = "#e02020";
    link.innerHTML = wishlistIcon();
    navTarget.parentElement.appendChild(link);

    const resume = document.createElement("a");
    resume.href = PAGE_WISHLIST;
    resume.setAttribute("data-oi-resume-link", "true");
    resume.textContent = "Reprendre ma selection";
    resume.style.marginInlineStart = "10px";
    resume.style.fontSize = "12px";
    resume.style.textDecoration = "none";
    resume.style.display = state.items.length ? "inline-block" : "none";
    navTarget.parentElement.appendChild(resume);

    document.addEventListener("oi:wishlist:updated", function () {
      resume.style.display = state.items.length ? "inline-block" : "none";
    });
  }

  function renderHomepageResumeBlock() {
    if (window.location.pathname !== "/") return;
    if (!state.items.length) return;
    if (document.querySelector("[data-oi-home-resume]")) return;
    const host = document.querySelector("#MainContent");
    if (!host) return;
    const block = document.createElement("div");
    block.setAttribute("data-oi-home-resume", "true");
    block.className = "oi-home-resume";
    block.innerHTML =
      "<p>Vous avez des favoris en attente</p>" +
      '<a href="' +
      PAGE_WISHLIST +
      '" class="oi-wishlist-action oi-wishlist-action--primary">Reprendre ma selection</a>';
    host.prepend(block);
  }

  function showToast(message) {
    let toast = document.getElementById("oiWishlistToast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "oiWishlistToast";
      toast.className = "oi-wishlist-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  function init() {
    state.items = readItems();
    let started = false;
    const startUI = function () {
      if (started) return;
      started = true;
      enhanceCards();
      initStaticPdpButtons();
      enhancePdp();
      renderWishlistPage();
      renderHeaderShortcut();
      renderHomepageResumeBlock();
    };
    hydrateWishlistFromShareUrl().finally(startUI);
    setTimeout(startUI, 120);

    const observer = new MutationObserver(function () {
      enhanceCards();
      initStaticPdpButtons();
      enhancePdp();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Some product templates mount late; retry shortly.
    setTimeout(enhancePdp, 600);
    setTimeout(enhancePdp, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
